import { render, staticRenderFns } from "./MaterialIndex.vue?vue&type=template&id=5578c6f6&"
import script from "./MaterialIndex.vue?vue&type=script&lang=js&"
export * from "./MaterialIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports